import {Component, OnInit, signal} from '@angular/core';
import {authConfigAbove, authConfigCastlabs} from './authConfig';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router, RouterOutlet} from '@angular/router';
import {PortalIdpService} from './services/portal-idp.service';
import {cleanLocalStorage} from './components/utils';
import {LoginPageComponent} from './components/login-page.component';
import {ContextService} from './services/context.service';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [RouterOutlet, LoginPageComponent],
})
export class AppComponent implements OnInit {
  loggedIn = signal(false);
  loggingIn = signal(true);

  constructor(
    public oAuthService: OAuthService,
    router: Router,
    private portalIdp: PortalIdpService,
    private contextService: ContextService
    /* Technically not needed here but it's loaded early enough  */
  ) {
    const isAbove = window.location.hostname.startsWith('above');
    this.portalIdp.setIdpName(isAbove ? 'above' : 'Castlabs');

    if (environment.localDev && !environment.env_name) {
      // No env chosen yet — show login page with env picker, skip OAuth.
      this.loggingIn.set(false);
      return;
    }

    oAuthService.setStorage(localStorage)
    oAuthService.configure(isAbove ? authConfigAbove : authConfigCastlabs);
    oAuthService.loadDiscoveryDocumentAndTryLogin().then(
      () => {
        this.loggedIn.set(oAuthService.hasValidAccessToken())
        this.loggingIn.set(false)
        if (oAuthService.hasValidAccessToken()) {
          sessionStorage.removeItem('post-logout-path');
          if (this.oAuthService.state) {
            console.log('Navigate back to URL before login');
            router.navigateByUrl(this.oAuthService.state, { replaceUrl: true });
          }
        }
      }
    );
    oAuthService.events.subscribe(() => {
      this.loggedIn.set(this.oAuthService.hasValidAccessToken())
    })
    oAuthService.setupAutomaticSilentRefresh()
  }

  ngOnInit(): void {
  }

  cleanLocalStorage() {
    cleanLocalStorage();
    sessionStorage.removeItem('post-logout-path')
  }
}
